"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.RequestOptionSelected=void 0;var l;(function(e){e.AllowOnce="allow_once",e.AllowWhileUsingApp="allow_while_using_app",e.DontAllow="dont_allow"})(l||(exports.RequestOptionSelected=l={}));
//# sourceMappingURL=RequestOptionSelected.js.map
